<template>
  <main class="h-screen w-full flex flex-col justify-center items-center bg-[#1A2238]">
    <h1 class="text-9xl font-extrabold text-white tracking-widest">404</h1>
    <div class="bg-green-500 text-white px-2 text-sm rounded-sm rotate-12 absolute">
      Page Not Found
    </div>
      <router-link to="/home" class="mt-10 flex mx-auto text-white bg-green-500 border-0 py-2 px-8 focus:outline-hidden hover:bg-green-600 rounded-sm text-lg">Go Home</router-link>
  </main>
</template>
